var _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.6332 28.9998C56.6332 44.8184 44.0324 57.631 28.502 57.631C12.9715 57.631 0.370675 44.8184 0.370675 28.9998C0.370675 13.1811 12.9715 0.368477 28.502 0.368477C44.0324 0.368477 56.6332 13.1811 56.6332 28.9998Z",
    fill: "#B3D237",
    stroke: "#B3D237",
    strokeWidth: 0.737443
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30.9749,
    height: 24.3356,
    transform: "translate(12 17)",
    fill: "#B3D237"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9062 35.6895C14.5879 37.591 13.3047 39.446 11.998 41.3242C16.9912 41.3242 21.9259 41.3242 26.8491 41.3242",
    stroke: "#1F1F21",
    strokeWidth: 0.737443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9375 41.3359C29.0194 41.3359 28.9726 41.3359 29.0545 41.3359",
    stroke: "#1F1F21",
    strokeWidth: 0.737443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1895 41.3358C35.1093 41.3358 39.0291 41.3358 42.9723 41.3358C40.1491 37.311 37.3842 33.3795 34.6193 29.448",
    stroke: "#1F1F21",
    strokeWidth: 0.737443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4869 27.8264C32.7286 26.7532 31.9703 25.6682 31.212 24.5833C28.2954 27.4998 25.5189 30.2413 22.8007 33.0179C22.0424 33.7878 21.3891 33.9162 20.6658 33.0529C20.1758 32.4696 19.6858 31.8979 19.0558 31.1513C18.4025 32.0963 17.7609 33.0062 17.1426 33.9162",
    stroke: "#1F1F21",
    strokeWidth: 0.737443,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5371 20.7451C26.1503 20.7451 28.6352 20.7451 31.1551 20.7451C31.1551 19.4385 31.1551 18.2252 31.1551 17.0002C28.5652 17.0002 26.0803 17.0002 23.5371 17.0002C23.5371 18.2719 23.5371 19.4385 23.5371 20.7451Z",
    stroke: "#1F1F21",
    strokeWidth: 0.737443,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2125 24.5761C31.1245 24.5761 31.0562 24.5078 31.0562 24.4198V20.8033C31.0562 20.7153 31.1245 20.647 31.2125 20.647C31.3005 20.647 31.3687 20.7153 31.3687 20.8033V24.4198C31.3687 24.5078 31.3005 24.5761 31.2125 24.5761Z",
    fill: "black",
    stroke: "#1F1F21",
    strokeWidth: 0.737443
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.ace83371f08c277522359e79f1ce7df2.svg";
export { ForwardRef as ReactComponent };